// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header___cYOhN","logo":"logo___vVfi2","logout":"logout___3KP_G","nav":"nav___36J9F","user":"user___1cHSF","name":"name___1qgAE"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Header/styles.scss
// module id = 277
// module chunks = 0